import { ClickIcon } from '@carboncopyco/icons';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { ModificationItem } from './ModificationItem';
import { unlockLabel } from './utils';

export const UnlockModificationItem = ({ id }: { id: string }) => {
  const flags = useFlags();
  return (
    <ModificationItem>
      <ModificationItem.Content>
        <ModificationItem.Icon>
          <ClickIcon size={18} />
        </ModificationItem.Icon>
        <ModificationItem.Text
          label={unlockLabel}
          tooltipLabel={
            flags.editorSpotManagerDebugMode
              ? `${unlockLabel} (${id})`
              : unlockLabel
          }
        />
      </ModificationItem.Content>
    </ModificationItem>
  );
};
